// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"e24e234b","375":"ff65b2c7","938":"d77c632e"}[chunkId] + ".chunk.js";
};